import React, { Fragment, useState } from 'react'
import CustomizedDialogs from '../../atoms/dialog'
import { Button, CircularProgress, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getHistoryData } from '../../../store/history/selectors';
import { useForm } from 'react-hook-form';
import { handleSnackBar, invokePostService, setReRender } from '../../../store/global/actions';
import { Alert } from '@material-ui/lab';
import { validateBlueprintName } from '../bluePrintComponents/SystemModel/helpers';

export default function BlueprintCloneDialog({isOpen=false, selectedItem, setActiveDialog}) {
    const dispatch = useDispatch();

	const historyData = useSelector(getHistoryData);
    const [open, setOpen] = useState(isOpen);
	const [cloneLoader, setCloneLoader] = useState(false);
	const { register, trigger, errors, control } = useForm();
	const [blueprintNameValidation, setBlueprintNameValidation] = useState("");
	const [cloneError, setCloneError] = useState()
    
	const [cloneFieldData, setCloneFieldData] = useState({
        name: "",
		description: ""
	})
    
    const toggleCloneConfirmation = (event) => {
        if(open){
            setActiveDialog(null)
        }
        setOpen((prev) => !prev)
    };

    const onClone = (event) => {
	  setCloneLoader(true);
      trigger().then((result) => {
          if (!result) {
              setCloneLoader(false);
              return;
          }
          const { name, description } = cloneFieldData;
          console.log(name);
          console.log(historyData, "history Data")
          console.log(selectedItem, "selecteditem")


          if (selectedItem && name != null | undefined) {
              dispatch(invokePostService('clone', { name, description, blueprintId: selectedItem._id, isClone:true })).then((res) => {
                  //invoke post service  for cloning a blueprint
                  //@params given- name:string decription:string bluprintId:selected._id:string
                  //response:data:true |false :boolean

                  if (res.data === true) {
                      setCloneLoader(false);
                      setOpen(false);
                      dispatch(handleSnackBar({ open: true, message: "Blueprint cloned successfully!", severity: "success" }));
                      dispatch(setReRender      ());

                  } else {
                      setCloneLoader(false);

                      setCloneError({ message: res.message })

                  }

              })

          }

      });
    };

  return (
        <CustomizedDialogs
			open={open}
			title="Clone Blueprint"
			handleClose={toggleCloneConfirmation}
			actions={
				<React.Fragment>
					<Button autoFocus onClick={toggleCloneConfirmation} variant="outlined" color="primary" style={{textTransform: 'capitalize'}} >
						Close
					</Button>
					<Button
						id="cloneButton"
						autoFocus
						variant="contained"
						color="primary"
						onClick={onClone}
						disabled={cloneLoader}
						startIcon={cloneLoader ? <CircularProgress color="secondary" size={20} /> : <Fragment />}
						style={{textTransform: 'capitalize'}}
					>
						Clone
					</Button>
				</React.Fragment>
			}
		>
			{cloneError != null | undefined ? <Alert style={{ marginBottom: 10 }} severity="error">{cloneError.message}</Alert> : null}
			<form>
				<TextField  
					InputLabelProps={{
						shrink: true,
					}}
					fullWidth
					required
					label={"Name"}
					variant="outlined"
					name="name"
					style={{ marginTop: 10 }}
					error={Boolean(errors.name)}
					onChange={(e) => {setCloneFieldData({ ...cloneFieldData, name: e.target.value })}}
					inputRef={register({ required: true, validate: validateBlueprintName })}
					helperText={errors.name ? errors?.name?.message : ""}
				/>
				<TextField
					id="clone_description"
					InputLabelProps={{
						shrink: true,
					}}
					// error={Boolean(errors?.description)}
					type={"text"}
					fullWidth
					rows={4}
					multiline={true}
					label={"Description"}
					placeholder={"Description"}
					variant="outlined"
					name="clone_description"
					style={{ marginTop: 20 }}
					onChange={(e) => setCloneFieldData({ ...cloneFieldData, description: e.target.value })}
				/>
			</form>
			{blueprintNameValidation && blueprintNameValidation.length && (
				<small style={{ color: "red" }}>
					&nbsp;&nbsp;
					{blueprintNameValidation}
					<br></br>
					<br></br>
				</small>
			)}
		</CustomizedDialogs>
  )
}
  

